/**
 * Badge d'etat d'immatriculation FNUCI (ICA Bike) pour un item.
 *
 * Statuts (cf. server/src/migrations/011_fnuci_icabike.sql) :
 *  - not_registered : pas encore tente
 *  - pending        : appel API en cours
 *  - registered     : OK, folder cree
 *  - error          : erreur reseau / HTTP / API → retryable
 *  - skipped        : donnees incompletes (email, adresse) ou client non assigne
 *
 * Si onRetry est fourni et le statut est 'error' ou 'skipped', un bouton
 * de relance s'affiche (admin/coordinator only).
 */

const PRESETS = {
  not_registered: { label: 'Non immat.', cls: 'bg-gray-100 text-gray-500' },
  pending:        { label: 'Immat. en cours', cls: 'bg-blue-100 text-blue-700' },
  registered:     { label: 'Immat. OK', cls: 'bg-emerald-100 text-emerald-700' },
  error:          { label: 'Immat. erreur', cls: 'bg-red-100 text-red-700' },
  skipped:        { label: 'Immat. ignoree', cls: 'bg-amber-100 text-amber-700' },
};

export default function FnuciBadge({ status, lastError, onRetry, retrying }) {
  if (!status) return null;
  const preset = PRESETS[status] || PRESETS.not_registered;
  const showRetry = typeof onRetry === 'function' && (status === 'error' || status === 'skipped');

  return (
    <span className="inline-flex items-center gap-1.5">
      <span
        className={`text-xs px-1.5 py-0.5 rounded-full ${preset.cls}`}
        title={lastError || ''}
      >
        {preset.label}
      </span>
      {showRetry && (
        <button
          type="button"
          onClick={onRetry}
          disabled={retrying}
          className="text-xs text-blue-600 hover:text-blue-800 underline disabled:opacity-50"
        >
          {retrying ? '...' : 'relancer'}
        </button>
      )}
    </span>
  );
}
